import "./style.css";

const EmailTemplateDetailsSkeleton = () => {
  return (
    <div className="etd-page">
      <div className="etd-layout">
        {/* Left */}
        <div className="etd-editor-panel">
          <div className="etd-card etd-editor-card">
            <div className="skeleton skeleton-title" />

            <div className="skeleton skeleton-toolbar" />

            <div className="skeleton skeleton-editor" />
          </div>
        </div>

        {/* Right */}
        <div className="etd-info-panel-wrapper">
          <div className="etd-info-panel">
            <div className="etd-card">
              <div className="skeleton skeleton-title" />

              <div className="skeleton skeleton-label" />
              <div className="skeleton skeleton-input" />

              <div className="skeleton skeleton-label" />
              <div className="skeleton skeleton-input" />

              <div className="skeleton skeleton-label" />
              <div className="skeleton skeleton-input" />
            </div>
          </div>

          <div className="etd-action-bar">
            <div className="skeleton skeleton-btn" />
            <div className="skeleton skeleton-btn" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplateDetailsSkeleton;
